import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { AcuityHistoryResponse, UUID } from "@/core/types";

import { acuityKeys } from "../keyFactory";
import { getAcuityHistory } from "../queryFunctions/getAcuityHistory";

type UseAcuityHistoryProps<TData = AcuityHistoryResponse> = {
  patientId: UUID;
  select?: (data: AcuityHistoryResponse) => TData;
};

type AcuityHistoryQueryOptions = UseQueryOptions<
  AcuityHistoryResponse,
  unknown,
  AcuityHistoryResponse,
  ReturnType<typeof acuityKeys.history>
>;

export function useAcuityHistory<TData = AcuityHistoryResponse>({
  patientId,
  select,
}: UseAcuityHistoryProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}

function optionFactory(patientId: UUID) {
  return {
    queryFn: () => getAcuityHistory(patientId),
    queryKey: acuityKeys.history(patientId),
  } satisfies AcuityHistoryQueryOptions;
}
